<template>
  <div class="company-privacy-container">
    <w-nav-bar nav_title="搜索屏蔽公司" @mobileLeftBtn="pageBack"></w-nav-bar>
    <div class="search-container">
      <div class="flex-column search-content">
        <span class="company-name">公司名称</span>
        <input type="text" v-model="keywords" placeholder="请输入公司名称" @input="inputChangeValue($event)">
      </div>
      <div class="search-result-container" v-show="searchResult.length">
        <cube-scroll :data="searchResult">
          <div class="search-item" v-for="item in searchResult" :key="item.token" v-html="item.nick_name_highlight || item.highlight" @click="selectItem(item)" />
        </cube-scroll>
      </div>
    </div>
    <div class="privacy-footer flex-center">
      <button class="theme-button" @click="blockingCompany" :disabled="!token">屏蔽该公司</button>
    </div>
  </div>
</template>

<script>
	import WNavBar from '../../components/global/w-navbar'
	import { componentsMixin } from '../../assets/js/mixin/components'

	export default {
		name: 'company-privacy',
		mixins: [ componentsMixin ],
		data () {
			return {
				keywords: '',
        searchResult: [],
        token: ''
			}
		},
		mounted () {
		},
		computed: {},
		watch: {},
		components: {
			WNavBar
		},
		methods: {
			pageBack () {
				this.$router.back()
      },
			async blockingCompany () {
				let res = await this.$api.user.addBlockCompany(this.token)
        if (res.code === 1000) {
	        this.$router.back()
        } else {
        	this.showToast(res.message)
        }
			},
      selectItem (item) {
				this.keywords = item.nick_name || item.name
        this.token = item.token
        this.searchResult = []
      },
			inputChangeValue (e) {
				if (!e.isComposing) {
					this.debounce(this.searchCompany, 300)
				}
			},
			async searchCompany () {
				let res = await this.$api.staticApi.companyComplete({
					keyword: this.keywords
				})
        if (res.code === 1000) this.searchResult = res.data
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/mixin';
  @import '@/assets/scss/global/variable';
  .company-privacy-container {
    @include mobile-container(44px, 78px);
    .search-container {
      position: relative;
      padding: 26px 24px;
      .company-name {
        font-size: $font-size-small;
        color: $color-dark-gray;
        margin-bottom: 4px;
      }
      input {
        border: none;
        padding: 12px 0;
        font-size: $font-size-medium-x;
        color: #404040;
        &::placeholder {
          color: #ececec;
        }
      }
      .search-content {
        border-bottom: 1px solid #EEEFF0;
      }
      .search-result-container {
        position: absolute;
        top: 86px;
        height: calc(var(--vh, 1vh) * 100 - 208px);
        .search-item {
          margin-top: 24px;
          color: $color-dark-gray;
          /deep/ .es-highlighter {
            color: $color-theme;
          }
        }
      }
    }
    .privacy-footer {
      position: fixed;
      bottom: 0;
      width: 100vw;
      padding: 18px 24px;
      background-color: $color-light;
      z-index: 9;
      button {
        width: 100%;
        height: 42px;
        border-radius: 4px;
        font-size: $font-size-medium-x;
        &:disabled {
          background-color: #CFCFCF;
          color: #FFFFFF;
        }
      }
    }
  }
</style>
